import * as React from 'react';
import styles from './userInfoComponents.module.scss';
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../utils/translations/translator';

interface OwnProps {}

export const DisabledBtn: React.FC<OwnProps> = ({}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.loginBtnWrapper}>
      <button disabled id={styles.loginBtn}>
        {tr(t, 'proceed-to-payment')}
      </button>
    </div>
  );
};
